import { render } from "./IVkUser.vue?vue&type=template&id=5fb5ab4c"
import script from "./IVkUser.vue?vue&type=script&lang=js"
export * from "./IVkUser.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__